import React, { Children, HTMLAttributes, useEffect, useState } from 'react'
import { NavDropdownToggle } from './NavDropdownToggle'
import { Square } from '../../../../../../shared/components/utility/square/Square'
import { IWithDropdownProps, withDropdown } from '../../../../../../shared/lib/hoc/WithDropdown'

const Dropdown = ({
  children,
  open,
  onToggle,
}: IWithDropdownProps & HTMLAttributes<HTMLElement>) => {
  const [isHidden, setIsHidden] = useState(!open)

  useEffect(() => {
    open ? setIsHidden(false) : setTimeout(() => setIsHidden(true), 150)
  })

  return (
    <div className='relative table select-none'>
      <div
        className={`absolute right-[calc(100%_-_52px)] top-[-18px] w-[320px] transition-opacity duration-150 ${
          open ? 'opacity-100' : 'opacity-0'
        } ${isHidden && 'invisible'}`}
      >
        <Square className='flex flex-col p-[32px] pt-[18px] pr-[65px]'>
          <ul className='list-none flex-col'>
            {Children.map(children, (child) => {
              return <li className='mb-[18px] last:mb-0'>{child}</li>
            })}
          </ul>
        </Square>
      </div>
      <NavDropdownToggle active={open} onClick={onToggle} />
    </div>
  )
}

export const NavDropdown = withDropdown(Dropdown)
